<template>
  <div
    v-if="tabs.length"
    class="ui-tabs"
  >
    <div class="ui-tabs-wrapper" v-if="!accordion">
      <ul class="ui-tabs-tabs" ref="tabs">
        <li
          v-for="tab in tabs"
          :key="tab.key"
          :class="{ active: tab.active }"
          @click="onClickTab(tab.key)"
        >
          {{ tab.name }}
          <ui-badge
            :text="tab.badge"
            color="#333"
          />
        </li>
        <div
          :style="underlineStyle"
          class="underline"
        />
      </ul>
    </div>

    <div :class="['ui-tabs-content', currentTab.contentClass]">
      <component
        v-if="currentTab.component"
        :is="currentTab.component"
      />
      <div
        v-else-if="currentTab.content"
        class="html-content"
        v-html="currentTab.content"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ui-tabs',

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    value: { // дефолтное значение, если нет хэша
      type: String,
      required: true,
    },

    accordion: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMounted: false,
    };
  },

  computed: {
    key: {
      set(k) {
        this.$f.replaceHash(k);
        this.$emit('input', k);
      },

      get() {
        return this.delayedHash || this.value;
      },
    },

    tabs() {
      return this.items.map(i => ({
        ...i,
        active: i.key === this.key,
      }));
    },

    activeIndex() {
      return this.tabs.findIndex(({ active }) => active) || 0;
    },

    currentTab() {
      return this.tabs[this.activeIndex];
    },

    underlineStyle() {
      if (!this.isMounted) return {};
      const tab = this.$refs?.tabs?.children[this.activeIndex];
      return tab
        ? {width: `${tab.offsetWidth}px`, left: `${tab.offsetLeft}px`}
        : {}
      ;
    },

    delayedHash() { // фиксит проблему вызова конкретного таба при SSR
      return this.isMounted ? this.$route?.hash?.slice(1) : '';
    }
  },

  watch: {
    '$route.hash'(val) {
      if (val) { // проверка, чтобы не реагировал на сброс хэша
        this.$refs.tabs.scrollIntoView({behavior: 'smooth'});
        this.$emit('input', val.slice(1));
      }
    }
  },

  mounted() {
    this.isMounted = true;

    this.$nextTick(() => {
      if (this.$route?.hash) { // если сразу указываем адрес с хешом - скролимся к табу
        this.$refs.tabs.scrollIntoView({behavior: 'smooth'});
        this.$emit('input', this.key); // эмит для мест, где контент дополнительно подгружается
      }
    })
  },

  methods: {
    onClickTab(key) {
      this.key = key;
      this.$emit('click-tab', key);
    },
  },
};
</script>

<style lang="scss">
.ui-tabs {
  &-wrapper {
    // оболочка, чтобы спрятать сроллбар в мобиле
    position: relative;
    margin: 0 (-$containerGapMobile);
    height: 36px;
    overflow: hidden;
    &::after {
      content: '';
      position: absolute;
      top: 35px;
      left: 0;
      right: 0;
      border-bottom: 1px solid $gray_lu;
      z-index: -1;
    }

    ul {
      margin: 0;
    }
  }

  &-tabs {
    display: flex;
    position: relative;
    overflow-y: auto;
    padding: 0 $containerGapMobile 40px;
    color: $gray;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }
  &-tabs > li {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 0;
    white-space: nowrap;
    &:not(:first-child) {
      margin-left: 24px;
    }

    &.active {
      color: $black;
      font-weight: 600;
      pointer-events: none;
    }
    .ui-badge {
      margin-left: 8px;
    }
  }

  .underline {
    display: block;
    position: absolute;
    top: 34px;
    left: 0;
    height: 2px;
    background-color: $black;
    transition: .3s left ease;
  }
}

@include breakpoint("desktop") {
  .ui-tabs {
    &-wrapper {
      margin: 0;
      height: auto;
      overflow: hidden;
      &::after {
        top: 53px;
      }
    }
    &-tabs {
      padding: 0;
      font-size: 16px;
      line-height: 24px;
    }
    &-tabs > li {
      padding: 15px 0;
      cursor: pointer;
      transition: .2s ease color;
      &::after {
        content: '';
        position: absolute;
        display: block;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: $gray;
        opacity: 0;
        transition: .2s opacity ease;
      }
      &:first-child::after {
        left: 0;
      }

      &:hover {
        color: $black;

        &::after {
          opacity: 1;
        }
      }
    }
    .underline {
      top: 52px;
    }
  }
}
</style>
